<template>
  <div class="content">
    <div class="tableTit">
      <p class="tabtitBg"></p>
      <h6>驳回</h6>
      <el-button class="titBtn" v-if="bjdelShow == true" type="warning" icon="el-icon-delete"
        @click="deleteClick">删除</el-button>
      <el-button class="titBtn" v-if="bjdelShow == false" type="warning" icon="el-icon-document-delete"
        @click="rejecting">驳回</el-button>
      <!-- <el-button class="titBtn" type="primary" icon="el-icon-document" @click="auditing">提交审核</el-button> -->
      <el-button class="titBtn" type="success" icon="el-icon-search" @click="search">搜索</el-button>
      <addressTree @obj="objdata"></addressTree>
      <el-select multiple placeholder="请选择类型" v-model="ydbType" @change="ydbTypeChange" class="titBtn"
        style="width: 260px;" clearable>
        <el-option label="大型坝" value="大型"></el-option>
        <el-option label="中型坝" value="中型"></el-option>
        <el-option label="小型坝" value="小型"></el-option>
      </el-select>

      <el-select v-model="county" placeholder="请选择县" class="titBtn" clearable>
        <el-option v-for="item in xianData" :key="item.regionCode" :label="item.regionName"
          :value="item.regionCode"></el-option>
      </el-select>

      <el-select v-model="city" placeholder="请选择市" @change="shiChange" class="titBtn" clearable>
        <el-option v-for="item in shiData" :key="item.regionCode" :label="item.regionName"
          :value="item.regionCode"></el-option>
      </el-select>
      <el-select v-model="province" placeholder="请选择省" @change="shengChange" class="titBtn" clearable>
        <el-option v-for="item in shengData" :key="item.regionCode" :label="item.regionName"
          :value="item.regionCode"></el-option>
      </el-select>
      <el-checkbox-group v-model="checkList" @change="checklistChange" v-if="bjdelShow == true">
        <el-checkbox label="登记"></el-checkbox>
        <el-checkbox label="编辑"></el-checkbox>
        <el-checkbox label="销号"></el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="tabBody">
      <el-table ref="multipleTable" @selection-change="handleSelectionChange"
        :header-cell-style="{ background: 'rgba(49,130,222,0.1)' }" :data="tabledata" :height="tableHeight" border>
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column type="index" align='center' width="45" label="序号"></el-table-column>
        <el-table-column prop="ydbLx" align='center' label="审核类型">
          <template slot-scope="scope">
            <p v-if="tabledata[scope.$index].ydbLx == '销号'" style="color: red">{{ tabledata[scope.$index].ydbLx }}</p>
            <p v-if="tabledata[scope.$index].ydbLx == '编辑'" style="color: orange">{{ tabledata[scope.$index].ydbLx }}
            </p>
            <p v-if="tabledata[scope.$index].ydbLx == '登记'" style="color: green">{{ tabledata[scope.$index].ydbLx }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="ydbSheng" align='center' label="省"></el-table-column>
        <el-table-column prop="ydbShi" align='center' label="市"></el-table-column>
        <el-table-column prop="ydbXian" align='center' label="县"></el-table-column>
        <el-table-column prop="ydbXiang" align='center' label="乡"></el-table-column>
        <el-table-column prop="ydbCun" align='center' label="村"></el-table-column>
        <el-table-column prop="ydbName" align='center' label="淤地坝名称"></el-table-column>
        <el-table-column prop="ydbCode" align='center' label="淤地坝编码"></el-table-column>
        <el-table-column prop="ydbSfwggb" align='center' label="淤地坝类型"></el-table-column>
        <el-table-column prop="ydbBhrq" align='center' label="驳回日期"></el-table-column>
        <el-table-column prop="operName" align='center' label="提交人"></el-table-column>
        <el-table-column prop="ydbPdfName" align='center' label="销号凭证">

      <template #default="scope">
        <span @click="handleRowClick(scope.row.attach)" class="table-btn btn-handle"><i class="ri-eye-line"></i><a :style="{ color: 'blue' }">{{getFileName(scope.row.attach)}}</a></span>
        <!-- <span @click="handleDownLoadClick(scope.row)" class="table-btn btn-handle"><i class="ri-download-2-line"></i>下载</span> -->
      </template>
    </el-table-column>
        <el-table-column prop="" label="操作" width="80" align="center">
          <template slot-scope="scope">
            <!--<el-tooltip class="item" effect="dark" content="下载" placement="top-start">
							<el-button type="primary" icon="el-icon-download" class="tableedit" round></el-button>
						</el-tooltip>-->
            <!--<el-tooltip class="item" effect="dark" content="预览" placement="top-start">
							<el-button type="success" icon="el-icon-view" class="tableedit" round></el-button>
						</el-tooltip>-->
            <!-- <el-button type="primary" icon="el-icon-download" class="tableedit" round
              @click='downloadrow(scope.$index,scope.row)'></el-button> -->
            <el-button type="success" icon="el-icon-edit" circle @click="edit(scope.$index, scope.row)"
              class="btnmargin" v-if="bjdelShow == true"></el-button>
            <el-button type="primary" icon="el-icon-view" circle @click="See(scope.$index, scope.row)"
              class="btnmargin"></el-button>
            <!-- <el-button type="warning" icon="el-icon-delete" circle @click="deletes(scope.$index,scope.row)" class="btnmargin"></el-button> -->
          </template>
        </el-table-column>
      </el-table>

    </div>

    <el-dialog
      title="预览"
      :visible.sync="PreviewDialogVisible"
      append-to-body
      width="70%"
      :style="{ 'position': 'fixed'}"
      center
      :before-close="closePdf"
    >
      <div>
        <iframe ref="pdfIframe" :src="pdfSrc" width="100%" height="600px" id="iframe"></iframe>
      </div>
    </el-dialog>

    <div class="fye">
      <pagintion ref="mypagintion" @dsydata='DsyData' @dstdata="DstData" :total='total' :pageNums="pageNums">
      </pagintion>
    </div>

    <rejectpopup v-if="dialogVisible == true" :mystate="Addsid" @bjadddata="Bjadddata" @getcancel="Getcancel">
    </rejectpopup>
  </div>
</template>

<script>
import addressTree from '@/components/mangement/addressTree.vue'
import pagintion from '@/components/mangement/pagintion.vue'

import rejectpopup from '../popup/rejectpopup.vue'
import Url from '@/common/js/Url.js'
import axios from 'axios'
import {
  selectRejectedYdb,
  deleteRejectedYdb,
  rejectedYdb,
  initRegion,
  getRegion
} from '@/api/api.js'
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 180,
      tabledata: [],
      total: null,
      pageSize: 20, // 每页多少条数据分页
      pageNum: 1, // 当前页
      pageNums: null,
      multipleSelection: [],
      dialogVisible: false,
      Addsid: [],
      PreviewDialogVisible: false,
      objdata1: null,
      checkList: ['登记', '编辑', '销号'],
      ydbLx: '',
      bjdelShow: false,
      shengData: null,
      shiData: null,
      xianData: null,
      ydbType: [],
      province: '',
      city: '',
      county: ''
    }
  },
  components: {
    addressTree,
    pagintion,
    rejectpopup
  },
  created() {
    // 执行initRegion方法，通过接口获取省
    initRegion().then((res) => {
      this.shengData = res.sheng
      this.shiData = res.shi
      this.xianData = res.xian
    })
  },
  mounted() {
    if (this.$store.state.name) {
      if (this.$store.state.name.indexOf('tjr') != -1 || this.$store.state.name.indexOf('zhuceren') != -1 || this.$store.state.name.indexOf('super') != -1) {
        this.bjdelShow = true
      } else {
        this.bjdelShow = false
      }
    } else {
      this.bjdelShow = false
    }

    const params = {
      pageSize: this.pageSize,
      pageNum: this.pageNum,
      ydbName: this.objdata1,
      ydbLx: this.checkList.toString()
    }
    this.list(params)
  },
  methods: {
    Bjadddata() {
      this.dialogVisible = false
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1,
        ydbLx: this.checkList.toString(),
        ydbShengCode: this.province == '' ? null : this.province,
        ydbShiCode: this.city == '' ? null : this.city,
        ydbXianCode: this.county == '' ? null : this.county,
        ydbSfwggbs: this.ydbType.length == 0 ? [] : this.ydbType
      }
      this.list(params)
    },
    Getcancel() {
      this.dialogVisible = false
    },

    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    edit(index, row) {
      // this.Addsid = [row]
      this.Addsid = ['bj', row]
      this.dialogVisible = true
    },
    See(index, row) {
      this.Addsid = ['ck', row]
      this.dialogVisible = true
    },
    downloadrow(index, row) {
      window.location.href = '/userApi/ydb/basic/downYdbInfo?id=' + row.id
    },
    treeClose() {
      this.objdata1 = null
      this.total = null
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1,
        ydbLx: this.ydbLx
      }
      this.list(params)
    },
    search() {
      this.tabledata = []
      this.total = null
      this.pageSize = 20
      this.pageNum = 1
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1,
        ydbLx: this.checkList.toString(),
        ydbShengCode: this.province == '' ? null : this.province,
        ydbShiCode: this.city == '' ? null : this.city,
        ydbXianCode: this.county == '' ? null : this.county,
        ydbSfwggbs: this.ydbType.length == 0 ? [] : this.ydbType
      }
      this.list(params)
    },

    objdata(data) {
      this.objdata1 = data
    },
    DsyData(data) { // 多少页
      this.pageNum = data.dsy
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1,
        ydbLx: this.checkList.toString(),
        ydbShengCode: this.province == '' ? null : this.province,
        ydbShiCode: this.city == '' ? null : this.city,
        ydbXianCode: this.county == '' ? null : this.county,
        ydbSfwggbs: this.ydbType.length == 0 ? [] : this.ydbType
      }
      this.list(params)
    },
    DstData(data) { // 多少条
      this.pageSize = data.dst
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1,
        ydbLx: this.checkList.toString(),
        ydbShengCode: this.province == '' ? null : this.province,
        ydbShiCode: this.city == '' ? null : this.city,
        ydbXianCode: this.county == '' ? null : this.county,
        ydbSfwggbs: this.ydbType.length == 0 ? [] : this.ydbType
      }
      this.list(params)
    },
    download() {
      window.location.href = '/userApi/ydb/basic/export'
    },

    list(params) {
      this.tabledata = []
      selectRejectedYdb(params).then((res) => {
        // console.log(res.data)
        this.total = res.total
        this.tabledata = res.data
      })
    },

    // 删除
    deleteClick() {
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: '提示',
          message: '请选择要删除的数据！',
          type: 'warning'
        })
      } else {
        this.$confirm('此操作将删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(action => {
          if (action === 'confirm') {
            const ids = []
            for (let i = 0; i < this.multipleSelection.length; i++) {
              ids.push(this.multipleSelection[i].id)
            }
            this.tabledata = this.tabledata.filter(function (item) {
              return ids.indexOf(item.id) < 0
            })
            deleteRejectedYdb(ids).then((res) => {
              if (res.code == 200) {
                this.$notify({
                  title: '提示',
                  message: '删除成功！',
                  type: 'success'
                })
              } else {
                this.$notify({
                  title: '提示',
                  message: '删除失败！',
                  type: 'error'
                })
              }
            })
          }
        }).catch(() => {
        })
      }
    },

    // 驳回操作
    rejecting() {
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: '提示',
          message: '请选择要驳回的数据！',
          type: 'warning'
        })
      } else {
        this.$confirm('此操作将驳回审核, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(action => {
          if (action === 'confirm') {
            const ids = []
            for (let i = 0; i < this.multipleSelection.length; i++) {
              ids.push(this.multipleSelection[i].id)
            }
            this.tabledata = this.tabledata.filter(function (item) {
              return ids.indexOf(item.id) < 0
            })
            rejectedYdb(this.multipleSelection).then((res) => {
              if (res.code == 200) {
                this.$notify({
                  title: '提示',
                  message: '驳回成功！',
                  type: 'success'
                })
                // let params = {
                //   pageSize: this.pageSize,
                //   pageNum: this.pageNum,
                //   ydbName: this.objdata1
                // };
                // this.list(params);
              } else {
                this.$notify({
                  title: '提示',
                  message: '驳回失败！',
                  type: 'error'
                })
              }
            })
          }
        }).catch(() => {
        })
      }
    },

    // 审核类型切换事件
    checklistChange() {
      // console.log(this.checkList)
      if (this.checkList.length == 0) {
        this.ydbLx = ''
        const params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          ydbName: this.objdata1,
          ydbLx: this.ydbLx,
          ydbShengCode: this.province == '' ? null : this.province,
          ydbShiCode: this.city == '' ? null : this.city,
          ydbXianCode: this.county == '' ? null : this.county,
          ydbSfwggbs: this.ydbType.length == 0 ? [] : this.ydbType
        }
        this.list(params)
      } else {
        this.ydbLx = this.checkList.toString()
        const params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          ydbName: this.objdata1,
          ydbLx: this.ydbLx,
          ydbShengCode: this.province == '' ? null : this.province,
          ydbShiCode: this.city == '' ? null : this.city,
          ydbXianCode: this.county == '' ? null : this.county,
          ydbSfwggbs: this.ydbType.length == 0 ? [] : this.ydbType
        }
        this.list(params)
      }
    },

    closePdf(){
      this.pdfSrc = '';
      this.PreviewDialogVisible=false;
    },

    handleRowClick(row) {
      const fileObj = JSON.parse(row)

      const fileName = fileObj.fileName
      // 构建请求URL，包含Access-Token
      const url = `/userApi/minio/viewFile/${fileName}`;
      // 构建请求头，包含Content-Type和Access-Token
      const headers = {
        "Access-Token": this.$store.state.token
      };

      fetch(url, {
          method: 'GET',
          headers: headers,
        })
          .then(response => response.blob())
          .then(blob2 => {
            if (blob2 instanceof Blob) {
              // 创建一个a标签用于下载
              const blob = new Blob([blob2], { type: "application/pdf" });
              this.pdfSrc = window.URL.createObjectURL(blob);
              this.$nextTick(() => {
                this.PreviewDialogVisible = true;
              });
            } else {
              // 如果响应不是文件流，处理错误
              console.error('Response is not a file stream');
            }
          })
          .catch(error => console.error('下载失败：', error));
    },
    getFileName(data){
      if(data){
        let fileObj = JSON.parse(data)
        return fileObj.filePath
      }

    }

  }
}
</script>

<style scoped>
  @import url('../../../common/css/mangementall.css');

  .zblxtree {
    width: 230px;
    height: calc(100% - 80px);
    height: -webkit-calc(100% - 80px);
    height: -moz-calc(100% - 80px);
    background: #f7f7f7;
    border-radius: 6px;
    float: left;
    overflow: auto;
    padding: 15px;
  }

  .zblxtreeSty {
    background: #f7f7f7;
    border-radius: 6px;
  }

  .tablelist {
    width: 100%;
    height: calc(100% - 50px);
    height: -webkit-calc(100% - 50px);
    height: -moz-calc(100% - 50px);
    float: right;
    position: relative;
  }

  .tablelistbox {
    width: 100%;
    heigt: 100%;
  }

  .clsjTis {
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;
    width: 335px;
    height: 210px;
    border: 1px solid #cccccc;
    background: #f7f7f7;
    border-radius: 6px;
    font-size: 16px;
  }

  .ycllxname {
    float: left;
    line-height: 30px;
    font-size: 14px;
    margin-left: 10px;
    margin-top: 10px;
  }

  .cllx-select {
    float: left;
    margin-top: 10px;
    width: 230px;
  }

  .btn {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }

  .zzct {
    font-size: 20px;
    margin-right: 10px;
  }

  .import-s {
    float: right;
    position: relative;
    width: 100px;
    height: 28px;
    background: #409eff;
    margin-right: 10px;
    border-radius: 4px;
    margin-top: 11px;
    overflow: hidden;
  }

  .import-s p {
    position: absolute;
    width: 100%;
    line-height: 28px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
  }

  .import-s p span {
    margin-right: 5px;
  }

  .import-s input {
    width: 100%;
    height: 28px;
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  >>>.el-input__inner {
    height: 30px;
    line-height: 30px;
    color: #606266;
    font-size: 14px;
  }

  >>>.el-checkbox-group {
    line-height: 50px;
    float: right;
    padding-right: 20px;
  }
</style>
